module.exports = __webpack_public_path__ + "static/media/arrow-down.bc2b1890.svg";